// extracted by mini-css-extract-plugin
module.exports = {"card_brand_list_wrapper":"PaymentMethodsSelector_card_brand_list_wrapper__um9aM"};